import React, { useState } from 'react';
import Home from './Home';
import ForwardCalculator from './ForwardCalculator';
import ReverseCalculator from './ReverseCalculator';
import About from './About';
import Contact from './Contact';
import Privacy from './Privacy';
import PensionGuide from './PensionGuide';

function App() {
  const [currentPage, setCurrentPage] = useState('home');

  const handleNavigation = (page) => {
    setCurrentPage(page);
  };

  const renderPage = () => {
    switch (currentPage) {
      case 'forward':
        return <ForwardCalculator />;
      case 'reverse':
        return <ReverseCalculator />;
      case 'about':
        return <About />;
      case 'contact':
        return <Contact />;
      case 'privacy':
        return <Privacy />;
      case 'guide':
        return <PensionGuide />;
      default:
        return <Home onNavigate={handleNavigation} />;
    }
  };

  return (
    <div>
      {/* 상단 네비게이션 바 */}
      {currentPage !== 'home' && (
        <nav className="navbar navbar-expand-lg navbar-light bg-white shadow-sm sticky-top">
          <div className="container">
            <button 
              className="btn btn-outline-primary me-3"
              onClick={() => setCurrentPage('home')}
            >
              <i className="fas fa-home me-2"></i>
              홈으로
            </button>

            <div className="navbar-nav flex-row d-none d-lg-flex">
              <button
                className={`btn me-2 ${currentPage === 'forward' ? 'btn-primary' : 'btn-outline-secondary'}`}
                onClick={() => setCurrentPage('forward')}
              >
                <i className="fas fa-calculator me-1"></i>
                일반 계산기
              </button>

              <button
                className={`btn me-2 ${currentPage === 'reverse' ? 'btn-success' : 'btn-outline-secondary'}`}
                onClick={() => setCurrentPage('reverse')}
              >
                <i className="fas fa-bullseye me-1"></i>
                역산 계산기
              </button>

              <button
                className={`btn me-2 ${currentPage === 'guide' ? 'btn-info' : 'btn-outline-secondary'}`}
                onClick={() => setCurrentPage('guide')}
              >
                <i className="fas fa-graduation-cap me-1"></i>
                연금 가이드
              </button>
            </div>

            {/* 모바일 메뉴 */}
            <div className="dropdown d-lg-none">
              <button className="btn btn-outline-secondary dropdown-toggle" type="button" data-bs-toggle="dropdown">
                <i className="fas fa-bars me-1"></i>
                메뉴
              </button>
              <ul className="dropdown-menu">
                <li><a className="dropdown-item" href="#" onClick={() => setCurrentPage('forward')}>
                  <i className="fas fa-calculator me-2"></i>일반 계산기</a></li>
                <li><a className="dropdown-item" href="#" onClick={() => setCurrentPage('reverse')}>
                  <i className="fas fa-bullseye me-2"></i>역산 계산기</a></li>
                <li><a className="dropdown-item" href="#" onClick={() => setCurrentPage('guide')}>
                  <i className="fas fa-graduation-cap me-2"></i>연금 가이드</a></li>
                <li><hr className="dropdown-divider" /></li>
                <li><a className="dropdown-item" href="#" onClick={() => setCurrentPage('about')}>
                  <i className="fas fa-info-circle me-2"></i>서비스 소개</a></li>
                <li><a className="dropdown-item" href="#" onClick={() => setCurrentPage('contact')}>
                  <i className="fas fa-envelope me-2"></i>문의하기</a></li>
              </ul>
            </div>

            <div className="navbar-text text-muted d-none d-lg-block">
              {currentPage === 'forward' && (
                <small>
                  <i className="fas fa-arrow-right me-1"></i>
                  저축액 → 생활비
                </small>
              )}
              {currentPage === 'reverse' && (
                <small>
                  <i className="fas fa-arrow-left me-1"></i>
                  생활비 → 저축액
                </small>
              )}
              {currentPage === 'guide' && (
                <small>
                  <i className="fas fa-book me-1"></i>
                  연금 학습 자료
                </small>
              )}
            </div>
          </div>
        </nav>
      )}

      {/* 하단 고정 푸터 (전체 페이지에 표시) */}
      {currentPage === 'home' && (
        <footer className="bg-dark text-white py-4 mt-auto">
          <div className="container">
            <div className="row">
              <div className="col-md-8">
                <h5 className="mb-3">
                  <i className="fas fa-piggy-bank me-2"></i>
                  라떼비버 노후연금 계산기
                </h5>
                <p className="mb-2">
                  두 가지 방식으로 노후 자금을 계획할 수 있는 전문 웹 서비스입니다.
                  복리 계산과 현금흐름 시뮬레이션을 통해 실질적인 노후 준비를 도와드립니다.
                </p>
                <p className="text-light small mb-0">
                  <i className="fas fa-exclamation-triangle me-1"></i>
                  본 서비스는 참고용으로만 사용하시고, 실제 투자 결정 시에는 전문가와 상담하시기 바랍니다.
                </p>
              </div>
              <div className="col-md-4">
                <h6 className="mb-3">사이트 정보</h6>
                <ul className="list-unstyled">
                  <li className="mb-2">
                    <a href="#" className="text-light text-decoration-none" onClick={() => setCurrentPage('about')}>
                      <i className="fas fa-info-circle me-2"></i>서비스 소개
                    </a>
                  </li>
                  <li className="mb-2">
                    <a href="#" className="text-light text-decoration-none" onClick={() => setCurrentPage('guide')}>
                      <i className="fas fa-graduation-cap me-2"></i>연금 가이드
                    </a>
                  </li>
                  <li className="mb-2">
                    <a href="#" className="text-light text-decoration-none" onClick={() => setCurrentPage('contact')}>
                      <i className="fas fa-envelope me-2"></i>문의하기
                    </a>
                  </li>
                  <li className="mb-2">
                    <a href="#" className="text-light text-decoration-none" onClick={() => setCurrentPage('privacy')}>
                      <i className="fas fa-shield-alt me-2"></i>개인정보처리방침
                    </a>
                  </li>
                </ul>
              </div>
            </div>
            <hr className="bg-light" />
            <div className="row align-items-center">
              <div className="col-md-6">
                <p className="mb-0 small">
                  © 2025 라떼비버 노후연금 계산기. All rights reserved.
                </p>
              </div>
              <div className="col-md-6 text-md-end">
                <p className="mb-0 small text-light">
                  <i className="fas fa-code me-1"></i>
                  Powered by React + FastAPI + Firebase
                </p>
              </div>
            </div>
          </div>
        </footer>
      )}

      {/* 페이지 컨텐츠 */}
      {renderPage()}
    </div>
  );
}

export default App;